import React, {FC} from 'react'
import {ITagModel, tagTextColor} from './TagModel'

export const TagChip: FC<{tag: ITagModel; onRemove?: (tag: ITagModel) => void; small?: boolean}> = ({
  tag,
  onRemove,
  small = true,
}) => (
  <span
    className={`badge d-inline-flex align-items-center gap-1 ${small ? 'fs-8 py-1 px-2' : 'fs-7 py-2 px-3'}`}
    style={{backgroundColor: tag.color, color: tagTextColor(tag.color)}}
  >
    {tag.name}
    {onRemove && (
      <button
        type='button'
        className='btn p-0 border-0 lh-1 ms-1'
        style={{color: 'inherit', fontSize: '0.65rem'}}
        title='Etiketi kaldır'
        onClick={(event) => {
          event.stopPropagation()
          onRemove(tag)
        }}
      >
        <i className='bi bi-x-lg' style={{color: 'inherit'}}></i>
      </button>
    )}
  </span>
)

/** Adayın etiketleri; onRemove verilirse her etiketin yanında kaldırma (x) görünür */
export const TagChips: FC<{tags?: ITagModel[] | null; onRemove?: (tag: ITagModel) => void}> = ({
  tags,
  onRemove,
}) =>
  tags && tags.length > 0 ? (
    <div className='d-flex flex-wrap gap-1 mt-1'>
      {tags.map((tag) => (
        <TagChip key={tag.id} tag={tag} onRemove={onRemove} />
      ))}
    </div>
  ) : null
